/*
 * JU!CE — motion do tema novo (vanilla, sem libs, sem dependência de framework).
 *
 * Três coisas, nesta ordem de importância:
 *   (a) reveal    — marca .jp-reveal com .is-in quando entra na viewport (uma vez).
 *   (b) <jp-parallax>  — desloca filhos [data-parallax="0.35"] com translate3d em rAF.
 *   (c) <jp-flavor-switch> — troca o sabor ativo (data-flavor + cross-fade de imagem),
 *                          no clique e, com data-autoplay="N", sozinho a cada N segundos.
 *
 * Nada roda antes do DOMContentLoaded. Sem JS, o conteúdo continua legível:
 * o CSS só esconde .jp-reveal quando o <html> tem a classe .js.
 */
(function () {
	'use strict';

	var MQ_REDUCE = '(prefers-reduced-motion: reduce)';
	var MQ_SMALL = '(max-width: 749px)';
	var PARALLAX_AMPLITUDE = 140; /* px de curso total em cada direção para razão 1 */

	function media(query) {
		return window.matchMedia ? window.matchMedia(query) : { matches: false, addListener: function () {} };
	}

	function onMediaChange(mql, handler) {
		if (typeof mql.addEventListener === 'function') {
			mql.addEventListener('change', handler);
		} else if (typeof mql.addListener === 'function') {
			mql.addListener(handler);
		}
	}

	function prefersReducedMotion() {
		return media(MQ_REDUCE).matches;
	}

	function toArray(list) {
		return Array.prototype.slice.call(list);
	}

	/* ------------------------------------------------------------------ */
	/* (a) Reveal                                                          */
	/* ------------------------------------------------------------------ */

	var revealObserver = null;

	function revealAll(nodes) {
		for (var i = 0; i < nodes.length; i++) {
			nodes[i].classList.add('is-in');
		}
	}

	function initReveal(scope) {
		var root = scope && scope.querySelectorAll ? scope : document;
		var nodes = toArray(root.querySelectorAll('.jp-reveal'));

		if (!nodes.length) {
			return;
		}

		if (!('IntersectionObserver' in window) || prefersReducedMotion()) {
			revealAll(nodes);
			return;
		}

		if (!revealObserver) {
			revealObserver = new IntersectionObserver(
				function (entries, observer) {
					for (var i = 0; i < entries.length; i++) {
						if (!entries[i].isIntersecting) {
							continue;
						}
						entries[i].target.classList.add('is-in');
						observer.unobserve(entries[i].target);
					}
				},
				{ root: null, rootMargin: '-10% 0px -10% 0px', threshold: 0 }
			);
		}

		for (var j = 0; j < nodes.length; j++) {
			if (!nodes[j].classList.contains('is-in')) {
				revealObserver.observe(nodes[j]);
			}
		}
	}

	/* ------------------------------------------------------------------ */
	/* (b) Parallax                                                        */
	/* ------------------------------------------------------------------ */

	var hosts = [];
	var frame = 0;

	function schedule() {
		if (frame) {
			return;
		}
		frame = window.requestAnimationFrame(function () {
			frame = 0;
			for (var i = 0; i < hosts.length; i++) {
				hosts[i].update();
			}
		});
	}

	function measureAll() {
		for (var i = 0; i < hosts.length; i++) {
			hosts[i].measure();
		}
		schedule();
	}

	class JpParallax extends HTMLElement {
		connectedCallback() {
			this.items = toArray(this.querySelectorAll('[data-parallax]'));

			if (!this.items.length) {
				return;
			}

			this.amplitude = parseFloat(this.getAttribute('data-parallax-amplitude')) || PARALLAX_AMPLITUDE;
			this.mqReduce = media(MQ_REDUCE);
			this.mqSmall = media(MQ_SMALL);
			this.visible = !('IntersectionObserver' in window);
			this.top = 0;
			this.height = 0;

			this.handleMedia = this.refresh.bind(this);
			onMediaChange(this.mqReduce, this.handleMedia);
			onMediaChange(this.mqSmall, this.handleMedia);

			if ('IntersectionObserver' in window) {
				this.observer = new IntersectionObserver(
					(entries) => {
						this.visible = entries[entries.length - 1].isIntersecting;
						schedule();
					},
					{ root: null, rootMargin: '25% 0px 25% 0px', threshold: 0 }
				);
				this.observer.observe(this);
			}

			if (hosts.indexOf(this) === -1) {
				hosts.push(this);
			}

			this.measure();
			this.refresh();
		}

		disconnectedCallback() {
			var index = hosts.indexOf(this);

			if (index > -1) {
				hosts.splice(index, 1);
			}

			if (this.observer) {
				this.observer.disconnect();
				this.observer = null;
			}

			this.reset();
		}

		/* Parallax só existe quando o movimento ajuda: nunca em reduced-motion e
		   nunca em telas < 750px, a menos que a seção peça com data-parallax-mobile. */
		isEnabled() {
			if (!this.mqReduce || this.mqReduce.matches) {
				return false;
			}

			return !this.mqSmall.matches || this.hasAttribute('data-parallax-mobile');
		}

		/* Mede uma vez (e a cada resize) para não ler layout dentro do rAF. */
		measure() {
			var rect = this.getBoundingClientRect();
			this.top = rect.top + (window.scrollY || window.pageYOffset || 0);
			this.height = rect.height;
		}

		reset() {
			if (!this.items) {
				return;
			}

			for (var i = 0; i < this.items.length; i++) {
				this.items[i].style.transform = '';
			}
		}

		refresh() {
			if (!this.isEnabled()) {
				this.reset();
				return;
			}

			this.measure();
			schedule();
		}

		update() {
			if (!this.isEnabled() || !this.visible || !this.height) {
				return;
			}

			var viewport = window.innerHeight || document.documentElement.clientHeight;
			var span = (viewport + this.height) / 2;

			if (span <= 0) {
				return;
			}

			/* progress: -1 (host abaixo da dobra) .. 0 (centrado) .. 1 (host acima). */
			var scroll = window.scrollY || window.pageYOffset || 0;
			var progress = (this.top + this.height / 2 - scroll - viewport / 2) / span;
			progress = Math.max(-1, Math.min(1, progress));

			for (var i = 0; i < this.items.length; i++) {
				var item = this.items[i];
				var ratio = parseFloat(item.getAttribute('data-parallax')) || 0;
				var offset = -progress * ratio * this.amplitude;
				item.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
			}
		}
	}

	/* ------------------------------------------------------------------ */
	/* (c) Troca de sabor                                                  */
	/* ------------------------------------------------------------------ */

	class JpFlavorSwitch extends HTMLElement {
		connectedCallback() {
			this.buttons = toArray(this.querySelectorAll('[data-flavor-target]'));

			if (!this.buttons.length) {
				return;
			}

			var selector = this.getAttribute('data-target');
			this.target = selector ? document.querySelector(selector) : null;

			if (!this.target) {
				this.target = this.closest('[data-flavor]');
			}

			if (!this.target) {
				return;
			}

			this.handleClick = this.onClick.bind(this);
			this.addEventListener('click', this.handleClick);
			this.sync(this.target.getAttribute('data-flavor'));

			/* O alvo (body) pode mudar de sabor por fora: jp-flavor.js aplicando o
			   sabor lembrado no localStorage na home (ele roda DEPOIS deste boot,
			   já que jp-flavor.js carrega depois de jp-motion.js), ou a PDP/carrinho
			   mandando via jp-flavor-key. Sem isto, os chips e o pote ficam parados
			   no sabor do primeiro render enquanto o fundo (CSS puro, herda
			   --jp-flavor) já trocou — pote/chip "Tangerina" com fundo de Uva.
			   Mesmo padrão do MutationObserver em assets/jp-hero.js. */
			if ('MutationObserver' in window) {
				this.handleTargetFlavorChange = this.onTargetFlavorChange.bind(this);
				this.targetObserver = new MutationObserver(this.handleTargetFlavorChange);
				this.targetObserver.observe(this.target, { attributes: true, attributeFilter: ['data-flavor'] });
			}

			this.initAutoplay();
		}

		disconnectedCallback() {
			if (this.handleClick) {
				this.removeEventListener('click', this.handleClick);
			}
			if (this.targetObserver) {
				this.targetObserver.disconnect();
			}
			this.teardownAutoplay();
		}

		onTargetFlavorChange() {
			this.sync(this.target.getAttribute('data-flavor'));
		}

		onClick(event) {
			var origin = event.target;

			if (!origin || typeof origin.closest !== 'function') {
				return;
			}

			var button = origin.closest('[data-flavor-target]');

			if (!button || !this.contains(button)) {
				return;
			}

			event.preventDefault();

			/* Escolha explícita vence o automático: a partir daqui o autoplay não
			   volta mais nesta página, nem depois de sair do hover. Vale inclusive
			   para o chip "em breve" — quem clicou está mexendo no seletor. */
			this.stopAutoplay();

			/* Sabor sem produto (ex.: Pitaya) não troca nada: só existe como aviso. */
			if (button.hasAttribute('data-soon') || button.getAttribute('aria-disabled') === 'true') {
				return;
			}

			this.select(button.getAttribute('data-flavor-target'));
		}

		/* options.auto = troca feita pelo autoplay, não pelo visitante. */
		select(flavor, options) {
			if (!flavor) {
				return;
			}

			var auto = !!(options && options.auto);

			if (flavor === this.target.getAttribute('data-flavor')) {
				this.sync(flavor);
				return;
			}

			/* data-flavor no alvo => --jp-flavor* trocam por CSS; o resto é transição. */
			this.target.setAttribute('data-flavor', flavor);
			this.sync(flavor);

			/* persist: false => assets/jp-flavor.js aplica o sabor mas NÃO grava no
			   localStorage. A home só lembra o sabor que a pessoa escolheu clicando;
			   o passeio automático não vira preferência. */
			this.dispatchEvent(
				new CustomEvent('jp:flavor-change', {
					bubbles: true,
					detail: { flavor: flavor, persist: !auto }
				})
			);
		}

		/* ---------------------------------------------------------------- */
		/* Autoplay — data-autoplay="5" na tag = troca de sabor a cada 5 s.    */
		/*                                                                    */
		/* Só existe quando a section pede (atributo presente e > 0), e nunca  */
		/* com prefers-reduced-motion. Roda enquanto a hero está >= 40% visível */
		/* e a aba está em foco; pausa no hover/foco da hero INTEIRA; e para   */
		/* de vez no clique num chip. O relógio reinicia do zero a cada troca. */
		/* ---------------------------------------------------------------- */

		initAutoplay() {
			/* Reconectar (Theme Editor reordenando seções) não pode deixar timer nem
			   listener duplicado para trás — e autoplayMs 0 desarma o que sobrou. */
			this.teardownAutoplay();
			this.autoplayMs = 0;

			var seconds = parseFloat(this.getAttribute('data-autoplay'));

			if (!seconds || seconds <= 0 || prefersReducedMotion()) {
				return;
			}

			this.autoplayMs = seconds * 1000;
			this.autoplayStopped = false;
			this.autoplayPaused = false;
			this.autoplayTimer = 0;
			/* Sem IntersectionObserver não dá para saber se a hero está na tela:
			   assume visível (o autoplay é enfeite, não pode sumir por isso). */
			this.autoplayVisible = !('IntersectionObserver' in window);

			/* A pausa é da hero inteira (copy + pote + chips), não só dos chips. */
			this.autoplayRoot = this.closest('.jp-hero') || this.closest('.shopify-section') || this;

			this.handleAutoplayPause = this.onAutoplayPause.bind(this);
			this.handleAutoplayResume = this.onAutoplayResume.bind(this);
			this.handleAutoplayVisibility = this.onAutoplayVisibility.bind(this);

			this.autoplayRoot.addEventListener('pointerenter', this.handleAutoplayPause);
			this.autoplayRoot.addEventListener('focusin', this.handleAutoplayPause);
			this.autoplayRoot.addEventListener('pointerleave', this.handleAutoplayResume);
			this.autoplayRoot.addEventListener('focusout', this.handleAutoplayResume);
			document.addEventListener('visibilitychange', this.handleAutoplayVisibility);

			if ('IntersectionObserver' in window) {
				this.autoplayObserver = new IntersectionObserver(
					(entries) => {
						var entry = entries[entries.length - 1];
						var viewport = window.innerHeight || document.documentElement.clientHeight || 0;
						/* Hero mais alta que a viewport nunca chega a 40% DE SI MESMA;
						   nesse caso vale o quanto dela ocupa a tela. */
						var coversViewport = viewport > 0 && entry.intersectionRect.height >= viewport * 0.4;

						this.autoplayVisible = entry.isIntersecting && (entry.intersectionRatio >= 0.4 || coversViewport);
						this.refreshAutoplay();
					},
					{ root: null, threshold: [0, 0.4, 0.75, 1] }
				);
				this.autoplayObserver.observe(this.autoplayRoot);
			}

			this.refreshAutoplay();
		}

		autoplayCanRun() {
			return !!this.autoplayMs && !this.autoplayStopped && !this.autoplayPaused && !!this.autoplayVisible && !document.hidden;
		}

		/* Reinicia o relógio do zero (a cada troca e ao voltar de uma pausa). */
		refreshAutoplay() {
			this.clearAutoplayTimer();

			if (!this.autoplayCanRun()) {
				return;
			}

			this.autoplayTimer = window.setTimeout(() => {
				this.autoplayTimer = 0;
				this.autoplayNext();
				this.refreshAutoplay();
			}, this.autoplayMs);
		}

		clearAutoplayTimer() {
			if (this.autoplayTimer) {
				window.clearTimeout(this.autoplayTimer);
				this.autoplayTimer = 0;
			}
		}

		onAutoplayPause() {
			this.autoplayPaused = true;
			this.clearAutoplayTimer();
		}

		onAutoplayResume(event) {
			/* pointerleave/focusout que não saem da hero de fato não contam. */
			if (event && event.relatedTarget && this.autoplayRoot && this.autoplayRoot.contains(event.relatedTarget)) {
				return;
			}

			this.autoplayPaused = false;
			this.refreshAutoplay();
		}

		onAutoplayVisibility() {
			this.refreshAutoplay();
		}

		/* Sem volta: só o clique num chip chama isto. */
		stopAutoplay() {
			this.autoplayStopped = true;
			this.clearAutoplayTimer();
		}

		/* Sabores elegíveis = os que trocam alguma coisa (fora os "em breve"). */
		autoplayFlavors() {
			var flavors = [];

			for (var i = 0; i < this.buttons.length; i++) {
				var button = this.buttons[i];

				if (button.hasAttribute('data-soon') || button.getAttribute('aria-disabled') === 'true') {
					continue;
				}

				var flavor = button.getAttribute('data-flavor-target');

				if (flavor && flavors.indexOf(flavor) === -1) {
					flavors.push(flavor);
				}
			}

			return flavors;
		}

		autoplayNext() {
			var flavors = this.autoplayFlavors();

			if (flavors.length < 2) {
				return;
			}

			/* Parte de onde o visitante já está (Liquid, localStorage ou PDP), nunca
			   de um sabor fixo; sabor fora da lista => começa do primeiro chip. */
			var index = flavors.indexOf(this.target.getAttribute('data-flavor'));

			this.select(flavors[(index + 1) % flavors.length], { auto: true });
		}

		teardownAutoplay() {
			this.clearAutoplayTimer();

			if (this.autoplayObserver) {
				this.autoplayObserver.disconnect();
				this.autoplayObserver = null;
			}

			if (this.autoplayRoot && this.handleAutoplayPause) {
				this.autoplayRoot.removeEventListener('pointerenter', this.handleAutoplayPause);
				this.autoplayRoot.removeEventListener('focusin', this.handleAutoplayPause);
				this.autoplayRoot.removeEventListener('pointerleave', this.handleAutoplayResume);
				this.autoplayRoot.removeEventListener('focusout', this.handleAutoplayResume);
			}

			if (this.handleAutoplayVisibility) {
				document.removeEventListener('visibilitychange', this.handleAutoplayVisibility);
			}
		}

		sync(flavor) {
			var i;

			for (i = 0; i < this.buttons.length; i++) {
				var button = this.buttons[i];
				button.setAttribute('aria-pressed', button.getAttribute('data-flavor-target') === flavor ? 'true' : 'false');
			}

			var images = toArray(this.target.querySelectorAll('[data-flavor-img]'));

			if (!images.length) {
				return;
			}

			var hasMatch = false;

			for (i = 0; i < images.length; i++) {
				if (images[i].getAttribute('data-flavor-img') === flavor) {
					hasMatch = true;
					break;
				}
			}

			/* Sem imagem para o sabor pedido, mantém a que está no ar (nunca vazio). */
			if (!hasMatch) {
				return;
			}

			for (i = 0; i < images.length; i++) {
				var active = images[i].getAttribute('data-flavor-img') === flavor;
				images[i].classList.toggle('is-active', active);
				images[i].setAttribute('aria-hidden', active ? 'false' : 'true');
			}
		}
	}

	/* ------------------------------------------------------------------ */
	/* Boot                                                                */
	/* ------------------------------------------------------------------ */

	function boot() {
		initReveal(document);

		if (!('customElements' in window)) {
			return;
		}

		if (!window.customElements.get('jp-parallax')) {
			window.customElements.define('jp-parallax', JpParallax);
		}

		if (!window.customElements.get('jp-flavor-switch')) {
			window.customElements.define('jp-flavor-switch', JpFlavorSwitch);
		}

		window.addEventListener('scroll', schedule, { passive: true });
		window.addEventListener('resize', measureAll, { passive: true });
		window.addEventListener('orientationchange', measureAll, { passive: true });
		window.addEventListener('load', measureAll);

		/* Theme Editor: seção re-renderizada precisa de reveal e de nova medição. */
		document.addEventListener('shopify:section:load', function (event) {
			initReveal(event.target);
			measureAll();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
